import { useMemo } from "react";
import { useAppSelector } from "Store/hooks";
import { selectUserList } from "../redux/selectors";
import { columns } from "./columns/columns";
import { Table } from "antd";

interface UsersTableProps {
  searchText?: string;
}

const UsersTable = ({ searchText = "" }: UsersTableProps) => {
  const usersList = useAppSelector(selectUserList);

  const filteredList = useMemo(() => {
    if (!searchText.trim()) return usersList;
    const term = searchText.toLowerCase();
    return usersList?.filter((user: any) =>
      [user.emailAddress, user.platform]
        .filter(Boolean)
        .some((field: string) => field.toLowerCase().includes(term))
    );
  }, [usersList, searchText]);

  return (
    <Table
      style={{ padding: "0px" }}
      columns={columns}
      dataSource={filteredList}
    />
  );
};
export default UsersTable;
